import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      backgroundColor: palette.common.orange,
      borderRadius: palette.borderRadius.default,
      display: 'flex',
      fontWeight: 600,
      color: palette.common.black,
      flexDirection: 'column',
      justifyContent: 'center',
      gap: '5px',
      height: '100%',
      padding: '10px 15px',
      userSelect: 'none',
      '& > div': {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        color: palette.text.white,
        fontSize: '1.4rem'
      }
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
